"use client";

import { AdminRole, UserRole } from "@/enums/roles.enum";
import { useSession } from "@/providers/SessionProvider";

interface UserWithRole {
  id: string;
  email: string;
  name: string;
  phone?: string;
  role?: UserRole | AdminRole;
}

export function useUserRole() {
  const { isAuthenticated, user } = useSession();

  // Use single role field from user session
  const userWithRole = (user as UserWithRole) || null;
  const resolvedRole = userWithRole?.role as UserRole | AdminRole | undefined;

  const isRealtorCandidate =
    !!resolvedRole &&
    [
      AdminRole.REALTOR,
      AdminRole.MAIN_REALTOR,
      AdminRole.SECRETARY,
      AdminRole.SUPER_ADMIN,
      AdminRole.ADMIN,
    ].includes(resolvedRole);

  // Realtor UI only for authenticated users with realtor-capable role
  const isRealtor = isAuthenticated && isRealtorCandidate;

  const isAdmin =
    !!resolvedRole &&
    (resolvedRole === AdminRole.ADMIN ||
      resolvedRole === AdminRole.SUPER_ADMIN);

  const isSuperAdmin = !!resolvedRole && resolvedRole === AdminRole.SUPER_ADMIN;

  const hasEnhancedAccess = isRealtor || isAdmin;

  return {
    user: userWithRole || null,
    userRole: resolvedRole,
    isAuthenticated,
    isRealtor,
    isAdmin,
    isSuperAdmin,
    hasEnhancedAccess,
  };
}
